var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2465 4.18606C11.0064 2.80451 12.9916 2.80452 13.7514 4.18606L21.3686 18.0357C22.1017 19.3685 21.1378 20.9994 19.6167 20.9995H4.38131C2.86025 20.9993 1.8963 19.3685 2.62935 18.0357L10.2465 4.18606ZM4.38131 18.9995H19.6167L11.9995 5.14993L4.38131 18.9995ZM11.9985 15.9995C12.5507 15.9995 12.9984 16.4474 12.9985 16.9995C12.9985 17.5518 12.5508 17.9995 11.9985 17.9995C11.4464 17.9994 10.9985 17.5517 10.9985 16.9995C10.9986 16.4475 11.4465 15.9997 11.9985 15.9995ZM12.9985 14.9995H10.9985V8.99954H12.9985V14.9995Z",
    fill: "#F9C642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDefault);
export default __webpack_public_path__ + "static/media/Warning-default.848c8a2df33c3398c93d0988cc39b359.svg";
export { ForwardRef as ReactComponent };